/**
 * Conversiones de unidades y redondeos. Funciones puras, sin dependencias.
 */
/** Kilogramos exactos por libra internacional (definición NIST). */
export const KG_PER_LB = 0.45359237;
/** Centímetros exactos por pulgada internacional. */
export const CM_PER_IN = 2.54;
/**
 * Redondea a un número fijo de decimales evitando los artefactos del binario
 * (`1.005 * 100 === 100.49999999999999`). No usa APIs de Node ni del DOM.
 */
export function roundTo(value, decimals = 0) {
    if (!Number.isFinite(value))
        return value;
    if (!Number.isInteger(decimals) || decimals < 0 || decimals > 15) {
        throw new RangeError('roundTo: decimals debe ser un entero entre 0 y 15');
    }
    if (Math.abs(value) >= 1e15)
        return value;
    const shifted = Math.round(Number(`${value}e${decimals}`));
    const result = Number(`${shifted}e-${decimals}`);
    return Object.is(result, -0) ? 0 : result;
}
/** Kilogramos → libras. */
export function kgToLb(kg) {
    return kg / KG_PER_LB;
}
/** Libras → kilogramos. */
export function lbToKg(lb) {
    return lb * KG_PER_LB;
}
/** Centímetros → pulgadas. */
export function cmToIn(cm) {
    return cm / CM_PER_IN;
}
/** Pulgadas → centímetros. */
export function inToCm(inches) {
    return inches * CM_PER_IN;
}
/**
 * Redondea una carga al múltiplo de disco más cercano (por defecto 2,5 kg,
 * el salto habitual con discos de 1,25 kg a cada lado de la barra).
 */
export function roundToPlate(weightKg, increment = 2.5) {
    if (!Number.isFinite(increment) || increment <= 0) {
        throw new RangeError('roundToPlate: increment debe ser un número positivo');
    }
    if (!Number.isFinite(weightKg)) {
        throw new RangeError('roundToPlate: weightKg debe ser un número finito');
    }
    return roundTo(Math.round(weightKg / increment) * increment, 3);
}
/** Formatea un peso guardado en kg en la unidad pedida, p. ej. `82.5 kg`. */
export function formatWeight(kg, unit, decimals = 1) {
    const value = unit === 'lb' ? kgToLb(kg) : kg;
    return `${roundTo(value, decimals)} ${unit}`;
}
//# sourceMappingURL=units.js.map